import React, { useCallback, useEffect, useState } from "react";
import { GET_ACCOUNTANTS, GET_ACCOUNTANTS_BY_ADMIN_ID } from "../../api/apiAdmin";
import CreateAccountant from "../organisms/contadores/CreateAccountant";
import AccountantsTable from "../organisms/contadores/AccountantsTable";
import CardTables from "../atoms/CardTables";
import GlobalSearch from "../organisms/buscadores/GlobalSearch";
import Fuse from "fuse.js";
import { useSession } from "../../context/SessionContext";
import CardHeader from "../atoms/CardHeader";
import Breadcrumb from "../molecules/Breadcrumb";

const ContadoresTemplate = () => {
    const [contadores, setContadores] = useState();
    const [filteredContadores, setFilteredContadores] = useState([]);
    const [loading, setLoading] = useState(false);
    const [filters, setFilters] = useState({ user: "", email: "" });
    const { user } = useSession();

    const getAccountants = useCallback (async () => {
		try {
            setLoading(true);
            let accountantsData;

            if (user?.roleInfo?.isSuperAdmin === true) {
                accountantsData = await GET_ACCOUNTANTS();
            } else {
                accountantsData = await GET_ACCOUNTANTS_BY_ADMIN_ID(user?.roleInfo?.id);
            }
            const sortedData = accountantsData.sort((a ,b) => a.id - b.id);
            setContadores(sortedData);
            setFilteredContadores(sortedData);
		} catch (error) {
			console.error(error);
		} finally {
            setLoading(false);
        }
	}, [user]);

	useEffect(() => { 
        getAccountants(); 
    }, [getAccountants]);

    useEffect(() => {
        if (!contadores) return;

        const options = {
            keys: ["name", "user.email"],
            threshold: 0.3,
        };

        const fuse = new Fuse(contadores, options);

        const searchTerms = `${filters?.user} ${filters?.email}`.trim();

        if (searchTerms) {
            const results = fuse.search(searchTerms).map(result => result.item);
            setFilteredContadores(results);
        } else {
            setFilteredContadores(contadores);
        }
    }, [filters, contadores]);

    return(
        <div className="flex flex-col space-y-2">
            <CardHeader>
            <Breadcrumb
                    items={[
                        { label: "Usuarios", to: "/usuarios" },
                        { label: "Contadores", to: null },
                    ]}
                />
                <CreateAccountant refetch={getAccountants} />
            </CardHeader>
            <CardTables>
                <GlobalSearch filters={filters} setFilters={setFilters} />
                <AccountantsTable data={filteredContadores} loading={loading} refetch={getAccountants}/>
            </CardTables>
        </div>
    )
};

export default ContadoresTemplate;